// ✅ Get API URL (Vite Standard)
const API_URL = process.env.REACT_APP_BACKEND_URL || "http://localhost:8000";

console.log("API_URL:", API_URL); // For debugging

export const api = {
  // Waitlist endpoints
  joinWaitlist: async (data) => {
    const response = await fetch(`${API_URL}/api/waitlist`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    return response;
  },

  getUser: async (phone) => {
    const response = await fetch(`${API_URL}/api/user/${phone}`, {
      method: "GET",
    });
    return response;
  },

  // Admin endpoints
  adminAuth: async (secret) => {
    const response = await fetch(`${API_URL}/api/admin/auth`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ secret }),
    });
    return response;
  },

  adminList: async (secret) => {
    const response = await fetch(`${API_URL}/api/admin/list`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ secret }),
    });
    return response;
  },

  adminExport: async (secret) => {
    const response = await fetch(`${API_URL}/api/admin/export`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ secret }),
    });
    return response;
  },
};